import { FC } from 'react';
import Link from 'next/link';
import { ActiveLine, Container, ContentWrapper } from './Content.style';
interface Props {
  activePath: string;
  onClosePopup: () => void;
}
const ProfileButtonContent: FC<Props> = ({
  activePath,
  onClosePopup
}: Props) => {
  return <Container onMouseLeave={onClosePopup}>
            <Link href={`${process.env.CDP_DOMAIN}/member`} onClick={onClosePopup}>
                <ActiveLine $isActive={false} />
                <ContentWrapper>บัญชีของฉัน</ContentWrapper>
            </Link>
            <Link href="/profile/favorite" onClick={onClosePopup}>
                <ActiveLine $isActive={activePath === 'profile/favorite'} />
                <ContentWrapper>รายการโปรด</ContentWrapper>
            </Link>
            <Link href="/profile/interesting" onClick={onClosePopup}>
                <ActiveLine $isActive={activePath === 'profile/interesting'} />
                <ContentWrapper>ความสนใจ</ContentWrapper>
            </Link>
            <Link href="/profile/setting" onClick={onClosePopup}>
                <ActiveLine $isActive={activePath === 'profile/setting'} />
                <ContentWrapper>การตั้งค่า</ContentWrapper>
            </Link>
        </Container>;
};
export default ProfileButtonContent;